export default "/assets/images/mila-product-white.15f480b661e80ecb.png";